import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom'
import { useEffect, useState } from 'react'
import FadeIn from 'react-fade-in'
import Header from './components/Header'
import GlassFilters from './components/GlassFilters'
import Home from './components/home/Home'
import Work from './components/work/Work'
import Projects from './components/projects/Projects'
import Life from './components/life/Life'
import Resume from './components/resume/Resume'
import { Analytics } from '@vercel/analytics/react'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'

const THEME_STORAGE_KEY = 'theme'
const DESIGN_STORAGE_KEY = 'design-language'

function AppContent({
  theme,
  setTheme,
  resolvedTheme,
  designLanguage,
  setDesignLanguage,
}) {
  const location = useLocation()

  return (
    <div className="App">
      {designLanguage === 'liquid-glass' && <GlassFilters />}
      <main>
        <Header
          theme={theme}
          setTheme={setTheme}
          resolvedTheme={resolvedTheme}
          designLanguage={designLanguage}
          setDesignLanguage={setDesignLanguage}
        />
        <FadeIn
          key={location.pathname}
          className="route-view"
          childClassName="route-view-stage"
          delay={0}
          transitionDuration={300}
        >
          <div className="page-shell">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/work" element={<Work />} />
              <Route
                path="/projects"
                element={<Projects designLanguage={designLanguage} />}
              />
              <Route path="/about" element={<Life />} />
              <Route path="/resume" element={<Resume />} />
            </Routes>
          </div>
        </FadeIn>
      </main>
      <footer className="App-footer">
        <p>Alan Pham, 2026</p>
      </footer>
    </div>
  )
}

function App() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem(THEME_STORAGE_KEY) || 'system'
  )
  const [resolvedTheme, setResolvedTheme] = useState(() => {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY) || 'system'

    if (storedTheme !== 'system') {
      return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
  })
  const [designLanguage, setDesignLanguage] = useState(
    () => localStorage.getItem(DESIGN_STORAGE_KEY) || 'liquid-glass'
  )

  useEffect(() => {
    const root = document.documentElement
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const applyTheme = () => {
      const resolved =
        theme === 'system' ? (mediaQuery.matches ? 'dark' : 'light') : theme
      root.setAttribute('data-theme', resolved)
      setResolvedTheme(resolved)
    }

    applyTheme()
    root.setAttribute('data-design', designLanguage)
    localStorage.setItem(THEME_STORAGE_KEY, theme)
    localStorage.setItem(DESIGN_STORAGE_KEY, designLanguage)

    if (theme === 'system') {
      mediaQuery.addEventListener('change', applyTheme)
    }

    return () => {
      mediaQuery.removeEventListener('change', applyTheme)
    }
  }, [theme, designLanguage])

  return (
    <Router>
      <Analytics />
      <AppContent
        theme={theme}
        setTheme={setTheme}
        resolvedTheme={resolvedTheme}
        designLanguage={designLanguage}
        setDesignLanguage={setDesignLanguage}
      />
    </Router>
  )
}

export default App
